import { render, staticRenderFns } from "./tabeleFordownload.vue?vue&type=template&id=3c7ef31c&scoped=true"
import script from "./tabeleFordownload.vue?vue&type=script&lang=js"
export * from "./tabeleFordownload.vue?vue&type=script&lang=js"
import style0 from "./tabeleFordownload.vue?vue&type=style&index=0&id=3c7ef31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ef31c",
  null
  
)

export default component.exports